<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCategory"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.category')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('sowing.reason_rejection')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center">
              3. {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-12">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ rejectedCauseCategoryForm.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{ $t('common_words.category_name') }}:</strong
                          >
                        </h6>
                        {{ rejectedCauseCategoryForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.crop') }}:</strong>
                        </h6>
                        {{ rejectedCauseCategoryForm.crop }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('sowing.reason_rejection') }}:</strong>
                        </h6>
                        <div
                          class="mb-2"
                          v-for="(
                            _, index
                          ) in rejectedCauseCategoryForm.rejected_quantity"
                          :key="index"
                        >
                          <el-tag
                            style="height: auto; color: black; width: 100%"
                            type="info"
                          >
                            <div class="row pt-2">
                              <div class="col-12 col-sm-8 col-lg-5">
                                <h6 class="mb-2">
                                  <strong
                                    >{{ $t('sowing.reason_rejection') }}
                                    {{ index + 1 }}</strong
                                  >
                                </h6>
                                <p>
                                  {{
                                    rejectedCauseCategoryForm
                                      .cause_rejected_name[index]
                                  }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-4 col-lg-2">
                                <h6 class="mb-2">
                                  <strong
                                    >{{ $t('common_words.status') }}
                                  </strong>
                                </h6>
                                <p>
                                  {{
                                    rejectedCauseCategoryForm.rejected_status[
                                      index
                                    ]
                                      ? $t('common_words.yes')
                                      : $t('common_words.no')
                                  }}
                                </p>
                              </div>
                            </div>
                          </el-tag>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { showContinue, resetObjectProperties } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      title: '',
      rejectedCauseCategoryForm: {
        user_id: this.$store.state.auth.user.id,
        cause_rejected_id: [],
        code: null,
        name: null,
        crop_ids: [],
        businesses_id: [],
        businesses_names: [],
        cause_rejected_name: [''],
        rejected_status: [true],
        rejected_quantity: 1,
      },
      renderComponent: true,
    };
  },

  computed: {},

  mixins: [MixinAlert, MixinLoading, MixinMenu, MixinPermissions],

  methods: {
    isSet(data) {
      return isset(data);
    },
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...resetObjectProperties({ ...this.$refs.firstStep.model }),
      };

      this.$set(this.$refs.firstStep.model, 'crop_ids', []);
      this.$set(this.$refs.firstStep.model, 'businesses_id', []);
      this.$set(this.$refs.firstStep.model, 'businesses_names', []);
      this.$set(this.$refs.firstStep, 'businessesInitial', []);

      this.$refs.secondStep.model = {
        ...resetObjectProperties({ ...this.$refs.secondStep.model }),
        rejected_status: [true],
        rejected_quantity: 1,
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      this.rejectedCauseCategoryForm = {
        ...this.rejectedCauseCategoryForm,
        ...model,
      };
    },

    storeUpdateCategory() {
      const payload = {
        id: this.rejectedCauseCategoryForm.id,
        route: 'rejecteds/categories',
        expected_rejected_count:
          this.rejectedCauseCategoryForm.rejected_quantity,
        business_ids: this.rejectedCauseCategoryForm.businesses_id,
        code: this.rejectedCauseCategoryForm.code,
        name: this.rejectedCauseCategoryForm.name,
        crop_ids: this.rejectedCauseCategoryForm.crop_ids,
        cause_rejected_clusters:
          this.rejectedCauseCategoryForm.cause_rejected_name.map(
            (motiveName, index) => ({
              id: this.rejectedCauseCategoryForm.cause_rejected_id[index],
              name: motiveName,
              status: this.rejectedCauseCategoryForm.rejected_status[index],
              user_id: this.rejectedCauseCategoryForm.user_id,
            })
          ),
      };

      this.showHideLoading(true);

      if (this.rejectedCauseCategoryForm.isEdit) {
        if (this.isUpdate()) {
          Axios.updateMaster(payload)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/rejecteds/categories',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(payload)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/rejecteds/categories',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('rejecteds');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('rejecteds');
  },
};
</script>
